// extracted by mini-css-extract-plugin
module.exports = {"citationInputTextArea":"input-text-area_citationInputTextArea__sIyC5","textarea":"input-text-area_textarea__TdnWO"};